/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

import Context from "lib/context";
import ServicesContext from "services/ServicesContext";

import * as types from "./App.types";

import { roles } from "data/models/roles";

import AuthRoute from "components/App/AuthRoute";
import AppError from "components/App/AppError";
import AppLoading from "components/App/AppLoading";

// import Home from "views/Home/Home";
import Radar from "views/Radar";

import "./App.css";
import "../../themes/Default";

export default class App extends React.Component<types.AppProps, types.AppState> {

   static contextType = Context;
   public context!: ServicesContext;

   constructor(props: types.AppProps) {
      super(props);

      this.state = {
         status: types.ApplicationStatus.Initializing
      }

   }

   public componentDidMount() {
      this.initAsync();
   }

   public render(): React.ReactNode {

      switch(this.state.status) {

         case types.ApplicationStatus.Running:
            return this.renderApp();

         case types.ApplicationStatus.Error:
            return <AppError />

         default:
            return <AppLoading />

      }

   }

   private renderApp(): React.ReactNode {

      return (
         <Router>

            <Switch>

               <Route exact path="/fatalError" component={AppError}></Route>

               {/*<Route exact path="/" component={Home}></Route>*/}

               <AuthRoute
                  path="/"
                  component={ Radar as any }
                  requiredRoles={ [
                     [ roles.authenticated ]
                  ] }
               />

               <Route path="*">
                  <Redirect to="/" />
               </Route>

            </Switch>

         </Router>
      )


   }

   private async initAsync(): Promise<void> {

      try {
         await this.context.api.initAsync();
         this.setState({ status: types.ApplicationStatus.Running });
      } catch(e) {
         this.setState({ status: types.ApplicationStatus.Error });
      }

   }

}
